<template>
  <div class="w-full">
    <div class="flex flex-col lg:flex-row w-full mb-4 space-y-3 lg:space-y-0 lg:space-x-4">
      <div class="w-fit h-fit flex space-x-3 place-self-center"
        ref="topList"
      >
        <Squares2X2Icon class="w-6 h-6 hover:cursor-pointer" :class="gridClasses" @click="viewGrid()" />
        <ListBulletIcon class="w-6 h-6 hover:cursor-pointer" :class="listClasses" @click="viewList()" />
        <Bars4Icon class="w-6 h-6 hover:cursor-pointer" :class="tableClasses" @click="viewTable()" />
      </div>
      <!-- <ais-state-results>
        <template v-slot="{ state }">
          <base-button
            borders="slim"
            padding="squared"
            elements-color="fill-gray-400 border-gray-300
                hover:fill-lh_red hover:border-lh_red
                dark:text-gray-100 dark:hover:text-slate-800"
            @click="handleExport(state)"
          >
            <template v-slot:icon>

            </template>
          </base-button>
        </template>
      </ais-state-results> -->
      <div class="w-full lg:hidden flex flex-wrap">
        <mobile-filters />
        <div class="mx-2">
          <p class="font-medium pb-1 w-fit flex cursor-pointer lg:cursor-default text-base uppercase leading-none"
            @click="buttonTime" @keydown="buttonTime"
          >
              Disponibile da
            <dropdown-arrow />
          </p>
          <div :class="`${filterTime} absolute left-4 bg-white dark:bg-lh_gray
          p-4 rounded-lg lg:p-0 z-50 lg:z-0 border lg:border-none`">
            <VueDatePicker
              v-model="date"
              :disabled-times="rangeDisabledTimes"
              model-type="yyyy-MM-dd"
              input-class-name="datepicker"
              :range="{ partialRange: false }"
              :enable-time-picker="false"
              @update:model-value="pushData()"
              placeholder="seleziona le date"
              @cleared="clearData()"
            />
            <div class="flex flex-col mt-3 space-y-3">
              <base-button
                v-for="period in periods"
                :key="period"
                @click="activePeriod(period)"
                :text="period.label"
                borders="slim"
                class="h-fit"
                elements-color="text-gray-700 border-gray-700 hover:bg-lh_red
                hover:text-white hover:border-lh_red
                dark:text-gray-100 dark:hover:text-lh_gray"
                :class="{ active: activeButton === period }"
              />
              <base-button
                text="clear time filter"
                @click="clearData()"
                borders="none"
                padding="none"
                elements-color="text-lh_red italic dark:text-gray-100"
              />
            </div>
          </div>
        </div>
      </div>
      <ais-search-box
        :placeholder="$t('frontoffice.products.searchProduct')"
        :class-names="{
          'ais-SearchBox': 'flex flex-grow',
          'ais-SearchBox-form': 'rounded-lg',
        }"
      />

    </div>
    <custom-pagination
      color="lh_red"
    />
    <ais-configure filters="availableForOrders:true" />
    <ais-hits
      :class-names="{
        'ais-Hits-list': `hits-list ${marginLayout}` ,
        'ais-Hits-item': `bg-transparent shadow-none p-0 overflow-hidden items-start ${itemBorder}`,
      }"
    >
      <template v-slot="{ items }">
        <p v-if="items.length === 0" class="text-xl italic p-2 text-center">{{ $t('apiErrors.notFound') }}</p>
      </template>
      <template v-slot:item="{ item }">
        <card-product-horizontal
          v-if="listLayout"
          :product="item"
        />
        <card-product-vertical
          v-if="gridLayout"
          :product="item"
        >
        </card-product-vertical>
        <product-table-layout
          v-if="tableLayout"
          :product="item"
        >
        </product-table-layout>
      </template>
    </ais-hits>
    <custom-pagination
      color="lh_red"
      @click.prevent="scrollToTop()"
    />
  </div>
</template>

<script>
// import { useToast } from 'vue-toastification';
import { mapActions, mapGetters } from 'vuex';
import getSearchClient from '@/utils/search-services';
import { AisSearchBox, AisConfigure } from 'vue-instantsearch/vue3/es';
import 'instantsearch.css/themes/satellite.css';
import BaseButton from '@/components/base/BaseButton.vue';
import CardProductHorizontal from '@/components/products/CardProductHorizontal.vue';
import CardProductVertical from '@/components/products/CardProductVertical.vue';
import ProductTableLayout from '@/components/products/ProductTableLayout.vue';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import MobileFilters from '@/components/base/MobileFilters.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import DropdownArrow from '@/components/graphic/DropdownArrow.vue';
import CustomPagination from '@/components/base/CustomPagination.vue';
import { Bars4Icon, Squares2X2Icon, ListBulletIcon } from '@heroicons/vue/24/outline';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  components: {
    BaseButton,
    AisSearchBox,
    AisConfigure,
    // AisStateResults,
    CardProductHorizontal,
    CardProductVertical,
    ProductTableLayout,
    MobileFilters,
    VueDatePicker,
    DropdownArrow,
    CustomPagination,
    Bars4Icon,
    Squares2X2Icon,
    ListBulletIcon,
  },
  // setup() {
  //   const toast = useToast();

  //   return { toast };
  // },
  data() {
    return {
      footerDirection: 'horizontal',
      searchClient: getSearchClient(),
      listLayout: false,
      gridLayout: true,
      tableLayout: false,
      timeFilter: this.periodFilter,
      periods: [
        {
          label: '1 week',
          startDate: dayjs().subtract(1, 'week').format('YYYY-MM-DD'),
        },
        {
          label: '1 month',
          startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        },
        {
          label: '3 months',
          startDate: dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
        },
      ],
      activeButton: null,
      date: null,
      rangeDisabledTimes: [
        { hours: 12, minutes: '*' },
        { hours: 9, minutes: 10 },
      ],
      showTime: false,
    };
  },
  props: {
    periodFilter: {
      type: Object,
    },
  },
  async created() {
    this.mobileView();
    await this.getVats();
    //    if (this.$route.query.filter === 'campaignId') {
    //      this.getCampaign(this.$route.query.value);
    //    }
  },
  computed: {
    ...mapGetters('customers', ['customer']),
    //    ...mapGetters('campaigns', ['campaign']),
    gridClasses() {
      return this.gridLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    listClasses() {
      return this.listLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    tableClasses() {
      return this.tableLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    tomorrow() {
      return dayjs().add(1, 'day').tz('UTC').unix();
    },
    lastFriday() {
      return dayjs().day(-2).tz('UTC').startOf('day')
        .unix();
    },
    nextThursday() {
      return dayjs().day(4).tz('UTC').endOf('day')
        .unix();
    },
    meilisearchFilters() {
      return `productCategorySlug=${this.$route.category} AND COMPATIBILITA=${this.$route.compatibility}`;
    },
    algoliaFilters() {
      if (this.$route.query.upcoming) {
        // eslint-disable-next-line max-len
        return `(availableFromUnix >= ${this.tomorrow}) AND productCategorySlug:${this.$route.query.category}`;
      }
      if (this.$route.query.latest) {
        // eslint-disable-next-line max-len
        return `(availableFromUnix:${this.lastFriday} TO ${this.nextThursday}) AND productCategorySlug:${this.$route.query.category}`;
      }
      if (this.$route.query.category) {
        // eslint-disable-next-line max-len
        return `${this.$route.query.filter}:${this.$route.query.value} AND productCategorySlug:${this.$route.query.category}`;
      }
      return `${this.$route.query.filter}:${this.$route.query.value}`;
    },
    currentQueryName() {
      const path = 'frontoffice.searchBox';
      return this.$route.query.category
        ? `${path}.${this.$route.query.category}` : `${path}.${this.$route.query.value}`;
    },
    currentCategory() {
      const translated = this.$t(this.currentQueryName);
      if (this.$route.query.filter === 'campaignId') {
        return this.$t('backoffice.navbar.campaigns');
      }
      if (translated.includes(this.currentQueryName)) {
        return this.$route.query.value;
      }
      return translated;
    },
    filtersKey() {
      if (process.env.VUE_APP_SCOUT_DRIVER === 'meilisearch') {
        return this.meilisearchFilters;
      }
      return this.algoliaFilters;
    },
    optionFilters() {
      return this.customer.showDiscontinuedStock ? 'isDiscontinued=false OR isDiscontinued=true'
        : 'isDiscontinued=false OR isDiscontinued=true AND outOfStock=false';
    },
    availablePeriod() {
      if (process.env.VUE_APP_SCOUT_DRIVER === 'meilisearch') {
        // eslint-disable-next-line max-len
        return `(availableFromUnix >= ${this.timeFilter.start} AND availableFromUnix <= ${this.timeFilter.end}) AND availableForOrders=true`;
      }
      return `availableFromUnix:${this.timeFilter.start} TO ${this.timeFilter.end} AND availableForOrders:true`;
    },
    today() {
      return dayjs(new Date()).format('YYYY-MM-DD');
    },
    filterTime() {
      return this.showTime ? 'open' : 'closed';
    },
    marginLayout() {
      if (this.gridLayout) {
        return 'grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4';
      }
      if (this.listLayout) {
        return 'flex flex-col';
      }
      return 'flex flex-col';
    },
    itemBorder() {
      if (this.tableLayout) {
        return 'border-b last:border-b';
      }
      return 'rounded-lg first-of-type:rounded-lg last-of-type:rounded-lg';
    },
  },
  methods: {
    ...mapActions('vats', ['getVats']),
    // ...mapActions('campaigns', ['getCampaign']),
    mobileView() {
      if (window.innerWidth < 768) {
        this.listLayout = false;
        this.gridLayout = true;
        this.tableLayout = false;
      }
    },
    viewGrid() {
      this.gridLayout = true;
      this.listLayout = false;
      this.tableLayout = false;
    },
    viewList() {
      this.listLayout = true;
      this.gridLayout = false;
      this.tableLayout = false;
    },
    viewTable() {
      this.tableLayout = true;
      this.listLayout = false;
      this.gridLayout = false;
    },
    scrollToTop() {
      this.$refs.topList.scrollIntoView({ behavior: 'smooth' });
    },
    activePeriod(period) {
      this.activeButton = period;
      if (period) {
        this.date = [period.startDate, this.today];
        this.timeFilter.start = dayjs(this.date[0]).unix();
        this.timeFilter.end = dayjs(this.date[1]).unix();
      }
    },
    pushData() {
      if (this.date != null) {
        this.timeFilter.start = dayjs.tz(this.date[0], 'UTC').unix();
        this.timeFilter.end = dayjs.tz(this.date[1], 'UTC').unix();
        this.activeButton = null;
      }
    },
    clearData() {
      this.date = null;
      this.timeFilter.start = null;
      this.timeFilter.end = null;
      this.activeButton = null;
    },
    buttonTime() {
      this.showTime = !this.showTime;
    },
    // handleExport(state) {
    //   const url = this.buildExportUrl(state);

    //   this.toast.info(
    //     'Non chiudere la nuova scheda fino al completamento del download',
    //     {
    //       timeout: 2000,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //     },
    //   );

    //   setTimeout(() => {
    //     const popup = window.open(url, '_blank');

    //     if (popup) {
    //       this.toast.success('Download avviato con successo', {
    //         timeout: 6000,
    //       });
    //     } else {
    //       this.toast.error('Non siamo riusciti ad aprire la nuova scheda. Controlla il blocco pop-up.');
    //     }
    //   }, 3000);
    // },
    // buildExportUrl(state) {
    //   const params = new URLSearchParams();

    //   const filterMap = {
    //     productCategorySlug: 'categorySlug',
    //     productSubcategorySlug: 'subcategorySlug',
    //     isEssential: 'isEssential',
    //     outOfStock: 'outOfStock',
    //   };
    //   if (this.$route.query.latest) {
    //     params.append('availableFrom', `${this.lastFriday}:${this.nextThursday}`);
    //   } else if (this.$route.query.upcoming) {
    //     params.append('availableFrom', `${this.tomorrow}:${Math.floor(Date.now() / 1000) + 3600 * 24 * 365}`);
    //   } else {
    //     const dateRange = state.numericRefinements?.availableFromUnix;
    //     if (dateRange?.['>='] && dateRange?.['<=']) {
    //       params.append('availableFrom', `${dateRange['>='][0]}:${dateRange['<='][0]}`);
    //     }
    //   }
    //   if (this.$route.query.filter === 'campaignId') {
    //     params.append('campaigns', this.campaign.title);
    //   }
    //   if (this.$route.query.category) {
    //     params.append('categorySlug', this.$route.query.category);
    //   }
    //   if (this.$route.query.filter && this.$route.query.value) {
    //     const exportFilter = filterMap[this.$route.query.filter];
    //     if (exportFilter) {
    //       params.append(exportFilter, this.$route.query.value);
    //     }
    //   }

    //   const refinements = state.disjunctiveFacetsRefinements || {};
    //   if (state.query) {
    //     params.append('query', state.query);
    //   }
    //   if (refinements.ETICHETTA?.length) {
    //     params.append('labels', refinements.ETICHETTA.join('~'));
    //   }
    //   if (refinements.AUTORE?.length) {
    //     params.append('authors', refinements.AUTORE.join('~'));
    //   }
    //   if (refinements.SUPPORTO?.length) {
    //     params.append('formats', refinements.SUPPORTO.join('~'));
    //   }
    //   if (refinements.productBrandName?.length) {
    //     params.append('brands', refinements.productBrandName.join('~'));
    //   }
    //   if (refinements.productSubcategoryName?.length) {
    //     params.append('subcategories', refinements.productSubcategoryName.join('~'));
    //   }
    //   if (this.$route.query.onlyInStock) {
    //     params.set('outOfStock', 'false');
    //   }

    //   return `/download-excel?${params.toString()}`;
    // },
  },
};
</script>

<style>
.hits-list {
  @apply justify-between
}
</style>
